module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBold-9163e0259349174f02bfec0e97ccfd67.otf";